<template>
  <div class="research_group_container">
    <div class="box">
      <div class= "box_1">
        <div class="main">
          <div class="outer_3">
          <div class="outer_attr" @click="autofocus('search_name')">
            <div class="group">
              <div class="attr_name">姓名</div>
              <input class="input_text" v-model.trim="nameQuery" id="search_name" type="text" placeholder="请输入被转赠人姓名">
            </div>
            <div class="container"><div class="empty" /></div> 
          </div>
          <div class="outer_attr" @click="autofocus('search_mobile')">
            <div class="group">
              <div class="attr_name">手机号</div>
              <input class="input_text" v-model.trim="mobileQuery" id="search_mobile" type="text" placeholder="请输入被转赠人手机号">
            </div>
            <div class="container"><div class="empty" /></div> 
          </div>
        </div>
        </div>
        <div class="button-group">
          <div class="button-up" style="width: 45%;" @click="$emit('toggleShow')"><span class="button-name" >返回上一步</span></div>
          <div class="button-wrap activity-background-color" style="width: 45%;" @click="searchContact()"><span class="button-name">搜索</span></div>
        </div>
      </div>
      <div class="box_2" v-if="contactDetail && contactDetail.customerName">
        <div class="main" >
        <div class="outer_3" >
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">姓名</span>
              <span class="attr">{{contactDetail.customerName}}</span>
            </div>
            <div class="container"><div class="empty" /></div> 
          </div>  
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">手机</span>
              <span class="attr">{{contactDetail.mobile}}</span>
            </div>
            <div class="container"><div class="empty" /></div> 
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">邮箱</span>
              <span class="attr">{{contactDetail.email}}</span>
            </div>
            <div class="container"><div class="empty" /></div> 
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">单位</span>
              <span class="attr">{{contactDetail.enterpriseName}}</span>
            </div>
            <div class="container"><div class="empty" /></div> 
          </div>
        </div>     
      </div>
        <div class="button-group">
          <div class="button-wrap activity-background-color" style="width: 100%;" @click="infoCollectionTransfer"><span class="button-name">转赠</span></div>
        </div>
      </div>
    </div>
    <RemindBox :remindParams="remindParams" @confirm="infoCollectionTransfer" v-if="showRemindBox" @toggleShow="toggleShowRemindBox"/>
  </div>
</template>
<script>
import {mapGetters, mapState} from 'vuex'
import $ from 'jquery'
import RemindBox from './RemindBox'
// import EMKT from '../../emkt'
export default {
  data () {
    return {
      mobileQuery: '',
      nameQuery: '',
      contactDetail: {},
      showRemindBox: false,
      remindParams: {
        firstline: '',
        secondline: '',
        singleOrDouble: 1
      }
    }
  },
  computed: {
    ...mapState([
      'sessionInfo'
    ]),
    ...mapGetters([
      'hasLogin'
    ])
  },
  components: {
    RemindBox
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    toggleShowRemindBox () {
      this.showRemindBox = !this.showRemindBox
    },
    validatemobile (mobile) {
      if (mobile.length === 0) {
        $.toast('手机号码不能为空')
        return false
      }
      let myreg = /^1[3-9]{1}[0-9]{9}$/
      if (mobile.length !== 11 || !myreg.test(mobile)) {
        $.toast('请输入有效的手机号码')
        return false
      }
      return true
    },
    resetWindow () {
      setTimeout(() => {
        window.scrollTo(0, 0)
        console.log('reset invoked')
      }, 300)
    },
    searchContact () {
      this.resetWindow()
      this.contactDetail = {}
      if (!this.nameQuery || !this.validatemobile(this.mobileQuery)) {
        $.toast('请输入姓名和正确的手机号')
        return
      }
      // 根据联系人手机号、姓名搜索联系人个人信息
      if (this.hasLogin) {
        const queryParam = {}
        queryParam.customerName = this.nameQuery
        queryParam.mobile = this.mobileQuery
        $.showPreloader('查询中')
        this.gcapi('@gcwwwifc/queryCustomerInfoByMobileAndName', queryParam).then(response => {
          $.hidePreloader()
          if (response && response.body === 'null') {
            this.remindParams.firstline = '该用户未注册'
            this.remindParams.secondline = '是否发送注册邀请？'
            this.remindParams.singleOrDouble = 2
            this.toggleShowRemindBox()
            return
          } else if (response && response.body.length > 0) {
            this.contactDetail = response.body[0]
          }
        }).catch(e => {
          console.log('e', e)
        })
      }
    },
    autofocus (id) {
      $('#' + id).focus()
    },
    infoCollectionTransfer () {
      this.$emit('finish', this.nameQuery, this.mobileQuery)
    }

  }
}
</script>
<style scoped>

html, body {
  height: 100%;
}
.activity-background-color {
  background-color: #5878fa;
}
.research_group_container {
  /*-webkit-overflow-scrolling:touch;*/
  /*margin-top: 20vw;*/
  height:100%;
  position: absolute;
  top: 20vw;
  flex-shrink: 0;
  overflow: scroll;
}

.box {
   align-items: center;
   background-color: #efeef3;
   width: 100%;
   height: 100vh;
   top: 10vw;
   left: 0;
 }
.box_1 {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100%;
}
.box_2 {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100%;
  margin-bottom: 6.67vw;
}

.main {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 4vw 0;
  width: 100%;
}

.outer_3 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  padding: 2vw 0;
}

.outer_attr {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 86.67vw;
  height:12.8vw;
}
.attr {
  opacity: 1;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.73vw;
  font-weight: 400;
}
.outer_3 .outer_attr:last-child .empty{
  width: 73.6vw;
  height: 0.53vw;
  border: 0;
}

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 73.6vw;
  height: 0.53vw;
}

.group {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 3.47vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.attr_name {
  opacity: 1;
  width: 7.47vw;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 500;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 4vw;
  width: 86.4vw;
}

.input_text {
  opacity: 1;
  text-align: left;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.73vw;
  font-weight: 400;
  width: 58vw;
  outline: none;
  border: none;
  padding: 0;
}


input::-webkit-input-placeholder {
  text-align: start;
  color: #D5D5D5;
}

.button-group {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  /*margin-top: 6.67vw;*/
  border-radius: 2.67vw;
  width: 100%;
  height: 13.33vw;
}
.button-up {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  height: 13.33vw;
  background-color: #fff;
  color: #5878fa;
}
.button-wrap {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  height: 13.33vw;
  color: #fff;
}


.button-name {
  opacity: 1;
  width: 100%;
  height: 5.33vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  /*color: #ffffff;*/
  font-size: 3.73vw;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// SearchContact.vue?1414774a